import {InputSProps} from "@FRAMEWORK/ui/types/d";
import React, {forwardRef} from "react";
import styled, {css} from "@yb/styled-px2rem";

interface Component extends InputSProps {
	id?: string;
	value: string;
	checked: boolean;
	bg?: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = styled.input<Component>`
	position: relative;
	width: 25px;
	height: 25px;
	padding: 0;
	border: none;
	background-color: #fff;
	cursor: pointer;
	border: 1px solid var(--line-color);

	&:checked {
		background-color: var(--emp-color);
		border: 1px solid var(--emp-color);
		&:after {
			position: absolute;
			left: 7px;
			top: 1px;
			width: 7px;
			height: 14px;
			border: solid #fff;
			border-width: 0 ${`2px`} ${`2px`} 0;
			transform: rotate(45deg);
			content: "";
		}
	}

	${props => {
		if (props.bg === "yellow") {
			return css`
				background-color: #f6f7f2;

				&:checked {
					background-color: var(--yellow-color);

					&:after {
						position: absolute;
						left: 5px;
						top: 1px;
						width: 6px;
						height: 10px;
						border: solid #fff;
						border-width: 0 3px 3px 0;
						transform: rotate(45deg);
						content: "";
					}
				}
			`;
		}
	}}
`;

const Checkbox = forwardRef<HTMLInputElement, Component>(({id, ...props}: Component, ref) => (
	<Input type="checkbox" id={id} {...props} ref={ref} title="상품비교 선택" />
));

export default Checkbox;
